<div class="question-view">
  <div class="header">
    <h1>{{question}}</h1>
  </div>

  <app-button-selection-group [multiSelection]="false" [options]="options" [submitted]="submitted" (selectedOptionsChange)="selectedOptionsChanged($event)"></app-button-selection-group>

  <app-button [text]="'Nächster Schritt'" (clickEvent)="handleNextClick()"></app-button>
</div>